<span
  class="tw-text-base tw-font-medium tw-text-dt-text-headings tw-p-2 tw-bg-dt-surface-elevated tw-rounded-lg"
  >{{ code }}</span
>
